import React from 'react';
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const LanguageSwitcher = ({ style }) => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleLanguageChange}
      style={{ 
        minWidth: '120px',
        ...style 
      }}
      suffixIcon={<GlobalOutlined />}
      size="large"
    >
      <Option value="en">
        <span style={{ marginRight: '8px' }}>🇺🇸</span>
        {t('language.en')}
      </Option>
      <Option value="zh">
        <span style={{ marginRight: '8px' }}>🇨🇳</span>
        {t('language.zh')}
      </Option>
    </Select>
  );
};

export default LanguageSwitcher;
